

<div class="mat-elevation-z8 container" style="font-family: 'Poppins', sans-serif;">
  <div class="head_result_e">
    <div class="head_left" style="width:100%;display:flex">
      <span class="head_msg" style="font-size:xx-large;font-weight:600;margin:0 10px;">{{inprogress?'Generating Ads':'My Recent Runs'}}</span>
      <mat-spinner style="margin:10px" *ngIf="inprogress" [diameter]="30"></mat-spinner>
    </div>
    <div class="head_right">
      <button mat-raised-button color="primary" [disabled]="inprogress" (click)="clearList()" *ngIf="dataSource.data.length>0">Clear</button>
      <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)">
      </mat-form-field>


    </div>
  </div>
  <table class="re_table" id="res_table_id" mat-table [dataSource]="dataSource" matSort>

    <!-- ID Column -->
    <ng-container matColumnDef="No">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
      <td mat-cell *matCellDef="let row;let i=index"> {{i+1}} </td>
    </ng-container>

    <!-- Progress Column -->
    <ng-container matColumnDef="Client">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Client </th>
      <td mat-cell *matCellDef="let row" [ngStyle]="{'color':row.msg!=='In-Progress'?colorFOrRow(row.msg,row.success):'black','font-weight':'bold'}"> {{row.client}} </td>
    </ng-container>

    <!-- Color Column -->
    <ng-container matColumnDef="Success">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Success </th>
      <td mat-cell *matCellDef="let row" [ngStyle]="{'color': colorFOrRow(row.msg,row.success),'font-weight':'bold'}"> {{row.success?'Yes':'No'}} </td>
    </ng-container>

    <ng-container matColumnDef="Message">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Message </th>
      <td mat-cell *matCellDef="let row" [ngStyle]="{'color': colorFOrRow(row.msg,row.success),'font-weight':'bold'}"> {{row.msg}} </td>
    </ng-container>
    <ng-container matColumnDef="dload" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Download </th>
      <td mat-cell *matCellDef="let row">
        <button *ngIf="appName=='anc' && row.verbose" [disabled]="!row.VisualisationFileName" (click)="openFile(row?.VisualisationFileName)" mat-mini-fab color="primary">
          <mat-icon>sim_card_download</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>

  <mat-paginator id="paginator_res" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>

